import { State } from 'modules';

export const tokenList = (state: State) => state.apiClientToken.tokenList;
export const tokensListLoaded = (state: State) =>
  state.apiClientToken.tokensListLoaded;
export const allTokensLoaded = (state: State) =>
  state.apiClientToken.allTokensLoaded;
export const loadTokensPending = (state: State) =>
  state.apiClientToken.loadTokensPending;
export const tokenFilters = (state: State) => state.apiClientToken.filters;
export const createdToken = (state: State) => state.apiClientToken.createdToken;
export const createTokenPending = (state: State) =>
  state.apiClientToken.createTokenPending;
